import { Modal, Button } from 'react-bootstrap'
import { BotUser } from '../../../../API/Users/models'
import { toast } from 'react-hot-toast'
import { toggleBlockedUser } from '../../../../API/Users/Users'

interface Props {
    show: boolean
    onHide: () => void
    user: BotUser | null
}

export const ToggleBlockModal = ({ show, onHide, user }: Props) => {
    const handleBlock = async () => {
        if (!user) return
        const response = await toggleBlockedUser({ userId: user?.id, blocked: !user?.blocked })
        if (response.success) {
            toast.success('Usuario bloqueado correctamente')
            onHide()
        } else {
            toast.error('Error al bloquear el usuario')
        }
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{user?.blocked ? 'Desbloquear' : 'Bloquear'} usuario <span className='text-primary'>{user?.name}</span></Modal.Title>
            </Modal.Header>
            <Modal.Body className='d-flex flex-column p-3'>
                <div className='d-flex justify-content-center flex-column gap-1'>
                    <p className='text-center'><b>¿Estás seguro de querer <span className='text-primaryy'>{user?.blocked ? 'desbloquear' : 'bloquear'}</span> el usuario {user?.name}?</b></p>
                    <p>Si {user?.blocked ? 'desbloqueas' : 'bloqueas'} el usuario, ya no podrá acceder a su cuenta mientras esté {user?.blocked ? 'desbloqueado' : 'bloqueado'}.</p>
                </div>
            </Modal.Body>
            <Modal.Footer>

                <div className='d-flex justify-content-center gap-2'>
                    <Button variant="primary" onClick={handleBlock}>
                        {user?.blocked ? 'Si, desbloquear' : 'Si, bloquear'}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
